import axios from "axios";

export function getDashboardOverviewFun() {
    return axios.get("/api/bms/dashboard/overview").then((res) => res.data);
}
